import React from "react";

// Single source for the event/goal/PR icon+color set - MilestoneLegend.js
// (the Milestones title bar's color key) and MilestoneRowHeader.js (one icon
// per milestone row, see its own comment) both draw from this so the two
// never drift apart. Keyed by the legend's own naming (events/goals/
// personalRecords), not the milestone data model's `kind` values (event/
// bodyWeight/personalRecord) - MILESTONE_KIND_TO_ICON_KEY bridges the two.
export const MILESTONE_KIND_TO_ICON_KEY = {
  event: "events",
  bodyWeight: "goals",
  personalRecord: "personalRecords",
};

export const MILESTONE_ICON_PATHS = {
  events: (
    <path d="M19,3H18V2a1,1,0,0,0-2,0V3H8V2A1,1,0,0,0,6,2V3H5A3,3,0,0,0,2,6V20a3,3,0,0,0,3,3H19a3,3,0,0,0,3-3V6A3,3,0,0,0,19,3ZM4,6A1,1,0,0,1,5,5H19a1,1,0,0,1,1,1V9H4ZM19,21H5a1,1,0,0,1-1-1V11H20V20A1,1,0,0,1,19,21Z" />
  ),
  goals: (
    <React.Fragment>
      <circle
        cx="12"
        cy="12"
        r="9"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
      />
      <circle
        cx="12"
        cy="12"
        r="5"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
      />
      <circle cx="12" cy="12" r="1.75" />
    </React.Fragment>
  ),
  personalRecords: (
    <path d="M12,1.5 L15.09,8.26 L22.5,9.27 L17.25,14.14 L18.68,21.5 L12,17.77 L5.32,21.5 L6.75,14.14 L1.5,9.27 L8.91,8.26 Z" />
  ),
};

// Colors are hardcoded in CSS (.milestone-kind-icon.<key>, .milestone-legend-
// item.<key>), not here - see annual-planner.css.
export const MilestoneKindIcon = ({ kind, className = "" }) => {
  const iconKey = MILESTONE_KIND_TO_ICON_KEY[kind];
  if (!iconKey) return null;

  return (
    <svg
      className={`milestone-kind-icon ${iconKey} ${className}`}
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
    >
      {MILESTONE_ICON_PATHS[iconKey]}
    </svg>
  );
};
